@use '@/styles/tokens' as *;

.row {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  width: 100%;
  padding: var(--space-4) 0;
  text-align: left;
  background: none;
  border: none;
  border-bottom: 1px solid $color-neutral-200;
  cursor: pointer;

  &:hover .title {
    color: var(--brand-500, #{$color-brand-700});
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px var(--focus-ring, rgb(120 140 40 / 25%));
    border-radius: 8px;
  }
}

.text {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  flex: 1;
  min-width: 0;
}

.title {
  font-size: 15px;
  font-weight: var(--font-weight-regular);
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.preview {
  font-size: 13px;
  font-weight: var(--font-weight-regular);
  color: var(--text-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.unread {
  font-weight: var(--font-weight-bold, 700);
  color: var(--text-primary);
}

.chevron {
  flex-shrink: 0;
  color: var(--text-muted);
}
